import { CAMPAIGNS_API_ENDPOINT } from "../../../constants/constant";
import baseApi from "../../baseApi";
import {
  ApiGetResponse,
  ApiGetResponseById,
  ApiResponse,
  CampaignAnalytics,
  UserQueryParams,
} from "./campaigns.type";

export const campaignApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTokenPriceConversionApiCall: build.query<ApiResponse<any>, void>({
      query: () => ({
        url: CAMPAIGNS_API_ENDPOINT.getBinGoldPrice,
        method: "GET",
      }),
    }),
    getCampaignsAnalyticsApiCall: build.query<
      ApiResponse<CampaignAnalytics>,
      void
    >({
      query: (params) => {
        // const queryParams = new URLSearchParams();

        // if (params?.search) queryParams.append("search", params.search);
        // if (params?.status) queryParams.append("status", params.status);

        return `${CAMPAIGNS_API_ENDPOINT.GET_CAMPAIGNS_ANALYTICS}`;
      },
      providesTags: ["CampaignsAnalytics"],
    }),

    getCampaignsApiCall: build.query<ApiGetResponse, UserQueryParams | void>({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append("search", params.search);
        if (params?.status) queryParams.append("status", params.status);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());

        return `${
          CAMPAIGNS_API_ENDPOINT.GET_CAMPAIGNS
        }?${queryParams.toString()}`;
      },
      providesTags: ["Campaigns"],
    }),

    getPrivatedCampaignsApiCall: build.query<
      ApiGetResponse,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append("search", params.search);
        if (params?.status) queryParams.append("status", params.status);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        if (params?.userId)
          queryParams.append("userId", params.userId.toString());

        return `${
          CAMPAIGNS_API_ENDPOINT.GET_ASSIGNED_CAMPAIGNS
        }?${queryParams.toString()}`;
      },
      providesTags: ["Campaigns"],
    }),

    getCodesApiCall: build.query<ApiGetResponse, UserQueryParams | void>({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        if (params?.campaignId)
          queryParams.append("campaignId", params.campaignId.toString());

        return `${CAMPAIGNS_API_ENDPOINT.GET_CODES}?${queryParams.toString()}`;
      },
      providesTags: ["Codes"],
    }),

    getCampaignsByIdApiCall: build.query<
      ApiGetResponseById,
      { campaignId: string }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.campaignId)
          queryParams.append("campaignId", params.campaignId);

        return `${
          CAMPAIGNS_API_ENDPOINT.GET_CAMPAIGN_BY_ID
        }?${queryParams.toString()}`;
      },
      providesTags: ["Campaigns"],
    }),

    createCampaignsApiCall: build.mutation<any, any>({
      query: (campaignsBody) => ({
        url: CAMPAIGNS_API_ENDPOINT.CREATE_CAMPAIGN,
        method: "POST",
        body: campaignsBody,
      }),
      invalidatesTags: ["Campaigns", "CampaignsAnalytics"],
    }),

    updateCampaignsApiCall: build.mutation<any, any>({
      query: (campaignsBody) => ({
        url: CAMPAIGNS_API_ENDPOINT.UPDATE_CAMPAIGN,
        method: "PUT",
        body: campaignsBody,
      }),
      invalidatesTags: ["Campaigns", "CampaignsAnalytics"],
    }),

    changeCampaignsStatusApiCall: build.mutation<ApiGetResponse, any>({
      query: (campaignsBody) => ({
        url: `${CAMPAIGNS_API_ENDPOINT.CHANGE_CAMPAIGN_STATUS}?campaignId=${campaignsBody.campaignId}&status=${campaignsBody.status}`,
        method: "PUT",
      }),
      invalidatesTags: ["Campaigns", "CampaignsAnalytics"],
    }),

    viewSocialsCredentialsApiCall: build.query<ApiGetResponse, UserQueryParams>(
      {
        query: (params) => {
          const queryParams = new URLSearchParams();
          if (params?.platform) queryParams.append("platform", params.platform);
          return `${
            CAMPAIGNS_API_ENDPOINT.VIEW_SOCIAL_CREDNETIALS
          }?${queryParams.toString()}`;
        },
      }
    ),
    getCampaignsAmountByIdApiCall: build.query<
      ApiGetResponseById,
      { campaignId: string }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.campaignId)
          queryParams.append("campaignId", params.campaignId);

        return `${
          CAMPAIGNS_API_ENDPOINT.GET_TOTAL_TASK_AMOUNT
        }?${queryParams.toString()}`;
      },
      providesTags: ["Campaigns"],
    }),
    generateCodes: build.mutation<ApiGetResponse, any>({
      query: ({ campaignId, count, userId }) => ({
        url: CAMPAIGNS_API_ENDPOINT.GENRATE_CODES, // or /campaigns/generate-codes
        method: "POST",
        body: {
          campaignId, // campaignId in body
          codeCounts: count, // how many codes to generate
          userId,
        },
      }),
      invalidatesTags: ["Codes"], // auto-refetch codes list after success
    }),
  }),
});

export const {
  useGetTokenPriceConversionApiCallQuery,

  useGetCampaignsApiCallQuery,
  useGetPrivatedCampaignsApiCallQuery,
  useGetCodesApiCallQuery,

  useGetCampaignsByIdApiCallQuery,
  useCreateCampaignsApiCallMutation,
  useUpdateCampaignsApiCallMutation,
  useGetCampaignsAnalyticsApiCallQuery,
  useChangeCampaignsStatusApiCallMutation,
  useViewSocialsCredentialsApiCallQuery,
  useGetCampaignsAmountByIdApiCallQuery,
  useGenerateCodesMutation,
} = campaignApiSlice;

export default campaignApiSlice;
